import { render, staticRenderFns } from "./bottomvan.vue?vue&type=template&id=73647b5a"
import script from "./bottomvan.vue?vue&type=script&lang=js"
export * from "./bottomvan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports